import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { BudgetedGLAccountSelectorResultDto } from '../../../cirabooks/shared-cirabooks-module/_models/accounts-payable/ap-bill/budgeted-gl-account-selector-result-dto';
import { DimensionSelectorResultDto } from '../../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
import { WFEBankAccountResultDto } from '../../../shared-workflow-module/_models/wfe-bank-account-result-dto';
import { WFEWorkflowRawDto } from '../../../shared-workflow-module/_models/wfe-workflow-raw-dto';
import { KeyValueResultDto } from '../../../_models/key-value-result-dto';
import { WFECommunityResultDto } from '../../../shared-workflow-module/_models/wfe-community-result-dto';
const ɵ0 = () => WFEWorkflowRawDto, ɵ1 = () => Date, ɵ2 = () => KeyValueResultDto, ɵ3 = () => WFECommunityResultDto, ɵ4 = () => WFEBankAccountResultDto, ɵ5 = () => BudgetedGLAccountSelectorResultDto, ɵ6 = () => DimensionSelectorResultDto;
export class WFEAccountantStepEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", WFEWorkflowRawDto)
], WFEAccountantStepEditorResultDto.prototype, "workflow", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], WFEAccountantStepEditorResultDto.prototype, "closedBookPeriod", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], WFEAccountantStepEditorResultDto.prototype, "wfStatusBreadcrumb", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], WFEAccountantStepEditorResultDto.prototype, "targetCommunityList", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], WFEAccountantStepEditorResultDto.prototype, "bankAccounts", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], WFEAccountantStepEditorResultDto.prototype, "glAccounts", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Array)
], WFEAccountantStepEditorResultDto.prototype, "dimensions", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
